import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const HashtagIcon = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <g transform="matrix(58.1877,0,0,58.1877,6.34004,46.0474)">
        <path d="M0.423,-0.523L0.247,-0.523L0.282,-0.711C0.286,-0.732 0.272,-0.753 0.251,-0.757C0.23,-0.761 0.209,-0.747 0.206,-0.726L0.167,-0.523L0.034,-0.523C0.012,-0.523 -0.006,-0.506 -0.006,-0.484C-0.006,-0.462 0.012,-0.445 0.034,-0.445L0.153,-0.445L0.125,-0.296L0.034,-0.296C0.012,-0.296 -0.006,-0.279 -0.006,-0.257C-0.006,-0.237 0.01,-0.221 0.029,-0.219L0.11,-0.219L0.078,-0.047C0.072,-0.019 0.095,-0.001 0.116,0C0.135,0 0.151,-0.013 0.155,-0.031L0.19,-0.218L0.366,-0.218L0.334,-0.047C0.329,-0.02 0.349,-0.001 0.372,0C0.391,0 0.407,-0.013 0.411,-0.031L0.446,-0.218L0.568,-0.218C0.589,-0.218 0.608,-0.236 0.608,-0.257C0.608,-0.278 0.589,-0.296 0.568,-0.296L0.46,-0.296L0.488,-0.445L0.574,-0.445C0.595,-0.445 0.613,-0.462 0.613,-0.484C0.613,-0.505 0.595,-0.523 0.574,-0.523L0.503,-0.523L0.538,-0.711C0.542,-0.732 0.529,-0.753 0.507,-0.757C0.486,-0.761 0.466,-0.747 0.462,-0.726L0.423,-0.523ZM0.232,-0.445L0.409,-0.445L0.381,-0.296L0.204,-0.296L0.232,-0.445Z" fill={fill}/>
      </g>
    </svg>
  );
};

HashtagIcon.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

HashtagIcon.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
